import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { sortOptions } from "../model";

interface QueuesFilterProps {
  filter: string;
  setFilter: (value: string) => void;
  sort: string;
  setSort: (value: string) => void;
}

export function QueuesFilter({
  filter,
  setFilter,
  sort,
  setSort,
}: QueuesFilterProps) {
  // Значение поля — локальное, а не прочитанное из URL. Раньше поле было
  // управляемым напрямую от searchParams, и при быстром наборе символы
  // терялись: пока React не прогонит цикл «setSearchParams → ререндер», поле
  // показывает прошлое значение, и следующее нажатие затирает набранное
  // (проверено на проде: «tran» превращалось в «n»).
  const [value, setValue] = useState(filter);

  // Догоняем внешние изменения фильтра — переход по истории браузера, ссылка
  // с готовым ?filter=
  useEffect(() => {
    setValue(filter);
  }, [filter]);

  return (
    <Card style={{ padding: 16 }}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            value={value}
            onChange={(event) => {
              setValue(event.target.value);
              setFilter(event.target.value);
            }}
            fullWidth
            label="Поиск по названию"
            variant="outlined"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            select
            value={sort}
            onChange={(event) => setSort(event.target.value)}
            fullWidth
            label="Сортировка"
            variant="outlined"
          >
            {sortOptions.map(({ value, label }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </Card>
  );
}
